<template>

	<div>

		<div class="search-section" style="background-image:url('frontend/img/comfy/giftcards_header.jpg')">
			<div class="container text-center">
				<h2 class="py-6 text-white font-weight-bold h2-ivomode">PROS</h2>
			</div>
		</div>

		<section class="p-t-b-50" style="background-image:url('frontend/img/comfy/comfy-terapeutas-background.png'); background-position: top right; background-repeat:no-repeat;">
			<div class="container">

				<div class="row my-5">
					<div class="center text-center">
						<h1 class="comfy-text font-weight-bold mb-0 mb-3">Afiliadas</h1>
						<h2 style="margin-top: -15px;" class="s-30 s-26-sm text-white font-weight-bold">
							<span class="comfy p-2">&nbsp;&nbsp;&nbsp; Comfy &nbsp;&nbsp;&nbsp;</span>
						</h2>
					</div>
				</div>

				<div class="row my-5">
					<div class="col-12">
						<div class="row service-blocks">

							<vs-card-group scroll>
								<vs-card type="1" v-for="terapeuta in terapeutas" :key="terapeuta.id">
									<template #title>
										<h2 class="font-weight-bold text-center comfy-text mb-2">{{ terapeuta.nombre }}</h2>
										<h4 class="font-weight-bold text-center comfy-text mb-2"><span class="comfy-second py-2 px-4">{{ terapeuta.ubicacion }}</span></h4>
									</template>
									<template #img>
										<img :src="urls3 + terapeuta.foto" alt="">
									</template>
									<template #text>
										<p>
											{{ terapeuta.descripcion }}
										</p>
										<img class="my-2" :src="url + '/frontend/img/comfy/comfy-terapeutas-separador.png'">
										<template>
											<el-row class="my-2">
												<el-col :span="6">
													<img :src="url + '/frontend/img/comfy/comfy-terapeutas-icon-masajes.png'" width="40">
												</el-col>
												<el-col :span="18">
													<vs-select placeholder="Técnicas" v-model="value">
														<vs-option v-for="masaje in terapeuta.masajes" :key="masaje.id">
															{{ masaje }}
														</vs-option>
													</vs-select>
												</el-col>
											</el-row>
										</template>
									</template>
									<template #interactions>
										<vs-button :color="terapeuta.color" icon>
											<img class="d-inline-block align-top" alt="" :src="url + '/frontend/img/comfy/comfy-icon-c.png'" width="30">
										</vs-button>
									</template>
								</vs-card>
							</vs-card-group>

						</div>
					</div>
				</div>
			</div>
		</section>

	</div>

</template>

<script>

	export default {
		components: {},
		props: [
			'cliente', 'url'
		],
		data() {
			return {
				urls3: 'https://ivo-comfy.s3.amazonaws.com/',
				terapeutas: '',
				value: ''
			}
		},
		watch: {

		},
		methods: {
			getTerapeutas(){
				var url = '/get-terapeutas'
				axios.get(url).then(response => {
					console.log(response.data.terapeutas)
					this.terapeutas = response.data.terapeutas
				}).catch(error => {
					console.log(error)
				})
			}
		},
		created() {

		},
		mounted() {
			// console.log('--- terapeutas component mounted ---')
			this.getTerapeutas()
		}
	};

</script>
<style type="text/css">
	.vs-card__title h2{
		font-size: 1.4rem;
	}
	.vs-card__title h4 span{
		border-radius: 12px;
	}
	.vs-card__interactions{
		top: 0px;
		bottom: auto;
		padding-top: 0px;
	}
	.vs-button--icon{
		padding-top: 10px;
		padding-bottom: 5px;
		margin-top: 0px;
		border-radius: 0px;
	}
	.vs-select-content{
		max-width: 100%;
	}
	.vs-select__input{
		background: #5cc0e9;
	}
	.vs-select__label{
		font-size: 1rem;
		opacity: 1;
		margin-bottom: auto;
		font-weight: bold;
	}
	.vs-select__option{
		max-height: 46px;
	}
	::-webkit-scrollbar {
		width: 5px;
		height: 5px;
		display: block;
		background: lightgrey;
	}
	::-webkit-scrollbar-thumb {
		background: #123b5a;
		border-radius: 5px;
	}
</style>